"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "roccalumera": {
    "b4bda3b3": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "skipSearch": false
    }],
    "cillia": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e51a40d": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "skipSearch": false
    }],
    "contrisa": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa77f379": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "skipSearch": false
    }],
    "galluffi": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "95cea20b": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "skipSearch": false
    }],
    "turco": [{
      "hkey": "974e8909",
      "slug": "roccalumera",
      "name": "Roccalumera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;